import { render } from "./ConsumeCard.vue?vue&type=template&id=68f11006"
import script from "./ConsumeCard.vue?vue&type=script&lang=js"
export * from "./ConsumeCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DevelopmentWork\\app\\JGJWork\\vue\\t3custom_2pos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__